(function (win, doc, $) {
    const { fetch: originalFetch } = win;

    window.minmax = {
      valid: true, // Zum Checkout weiterlassen oder nicht
      reason: "", // Grund für Error msg
      cart: null, // Cart Objekt für Progress Bar
      discountApplied: false, // Rabattcode angewendet oder nicht
      ajaxCart: null, // ajaxCart Objekt von Shopify
    };
  
    win.fetch = async (...args) => {
      let [resource, config] = args;
      const data = await originalFetch(...args);
  
      if (resource.includes("intercept=false")) {
        return data;
      }
  
      if (resource && resource.includes && resource.includes("/wallets/checkouts/")) {
        const responseData = await data.clone().json(); // Cart Daten von Discount App
        const ajaxCartPlain = await originalFetch('/cart.js'); // Cart Daten von Cart Ajax Objekt
        const ajaxCart = await (ajaxCartPlain.json());       
  
        // Ist hier ein discount gesetzt ist ein discount angewendet
        if (responseData.checkout.discount_code) {
          window.minmax.discountApplied = true;
        } else {
          window.minmax.discountApplied = false;
        }
        
        window.minmax.cart = responseData.checkout;
        window.minmax.cart.items = responseData.checkout.line_items;
        responseData.checkout.subtotalCents = parseInt(responseData.checkout.total_price.replace(".", ""));
        validateCart(responseData.checkout, ajaxCart );
      }
  
      // Gibt es ein Discount Code cart/add/change nicht beachten
      else if (resource.includes("change")) {
        // Nur fetchen wenn kein gutscheincode aktiv ist!
        if (!window.minmax.discountApplied) {
          fetch("/cart.js");
        }

      } else if (resource && resource.includes && resource.includes("cart/add")) {
        // Nur fetchen wenn kein gutscheincode aktiv ist!
          if (!window.minmax.discountApplied) {
            fetch("/cart.js");
          }

          // let subtotalCents;
          // console.log(window.minmax.cart);
          // if (window.minmax.cart.subtotalCents){
          //   subtotalCentsSecond = window.minmax.cart.subtotalCents;
          // } else {
          //   subtotalCents = window.minmax.cart.total_price;
          // }

          // const response = await data.clone().json();
          // if (response.price == 0 && subtotalCents < window.Schmuko.freeGoal * 100){
          //   window.minmax.reason = win.Schmuko.limits.textFree.replace(/\$1/g, `${win.Schmuko.limits.free}€`);
          //   window.minmax.valid = false;
          //   openModal();
          // }

      } else if (resource && resource.includes && resource.includes("cart.js")) {
        if (!window.minmax.discountApplied) {
          window.minmax.valid = true;
          const cartReponse = await data.clone().json();
          window.minmax.cart = cartReponse;
          validateCart();
        } 
        else {
          const discountData = JSON.parse(window.sessionStorage.getItem("scDiscountData"));
          window.minmax.cart = discountData;
          // const cartReponse = await data.clone().json();
          // validateCart(discountData, cartReponse);
        }
        const cartFetchEvent = new CustomEvent('cartFetchEvent');
        window.dispatchEvent(cartFetchEvent);
      }
      return data;
    };
  
    function validateCart(discountData, ajaxCart) {
      window.minmax.reason = "";
      window.minmax.valid = true;
      let subtotal = window.minmax.cart.items_subtotal_price;
      if (discountData) {
        if (discountData.subtotalCents > 0) {
          subtotal = discountData.subtotalCents;
        }
      }

      // MBW Checken
      if (subtotal < win.Schmuko.limits.mbw * 100 && subtotal !== 0) {
        window.minmax.valid = false;
        window.minmax.reason = win.Schmuko.limits.textMbw.replace("$1", `${win.Schmuko.limits.mbw}€`);
      }

      // Checken ob nur ein 0 euro Produkt vorhanden ist
      let freeCount = 0;

      if (ajaxCart) {
        for (const item of ajaxCart.items) {
          const price = item.final_price ?? parseFloat(item.price);
          if (price == 0) {
            freeCount += item.quantity;
          }
         if (freeCount > 1){
            window.minmax.reason = win.Schmuko.limits.textOnlyOne;
            window.minmax.valid = false;
          }
        }
      } else {
        for (const item of window.minmax.cart.items) {
          const price = item.final_price ?? parseFloat(item.price);
          if (price == 0) {
            freeCount += item.quantity;
          }
          if (freeCount > 1) {
            window.minmax.reason = win.Schmuko.limits.textOnlyOne;
            window.minmax.valid = false;
            break;
          }
        }
      }
 
      // Haben wir ein Free produkt muss der MBW bei 30 Euro liegen!
      if (freeCount > 0) {
        if (subtotal < win.Schmuko.limits.free * 100) {
          window.minmax.reason = win.Schmuko.limits.textFree.replace(/\$1/g, `${win.Schmuko.limits.free}€`);
          window.minmax.valid = false;
        }
      }
  
      
      if (!window.minmax.valid) {
        changeCheckoutButtonCaption(win.Schmuko.limits.textInvalid);
        openModal();
      } else {
        changeCheckoutButtonCaption(window.cartStrings.checkout);
      }
      
  
      if (window && window.Schmuko && window.Schmuko.cartValueCallback) {
        window.Schmuko.cartValueCallback(subtotal / 100);
      }
    }
  
    function openModal() { 
      const modal = doc.getElementById("minmax-modal");
      modal.setTitle(win.Schmuko.limits.textInvalidHeading);
      modal.setContent(window.minmax.reason);
      modal.open();
    }
  
    function changeCheckoutButtonCaption(caption) {
      const checkoutButtons = doc.querySelectorAll('button[name="checkout"]');
      checkoutButtons.forEach((button) => {
        button.innerHTML = caption;
      });
    }
  
    doc.addEventListener("click", (e) => {
      if (e.target.matches('button[name="checkout"]')) {
        if (!window.minmax.valid) {
          changeCheckoutButtonCaption(win.Schmuko.limits.textInvalid);
          openModal();
          e.preventDefault();
        } else {
          changeCheckoutButtonCaption(window.cartStrings.checkout);
        }
      }

      let subtotalCents;
      if (window.minmax.cart.subtotalCents){
        subtotalCents = window.minmax.cart.subtotalCents;
      } else {
        subtotalCents = window.minmax.cart.total_price;
      }

      if (e.target.matches('button[name="add"]')) {
        let productPrice = e.target.getAttribute('data-price');

        if (productPrice == 0 && subtotalCents < window.Schmuko.freeGoal * 100) {
          window.minmax.reason = win.Schmuko.limits.textFree.replace(/\$1/g, `${win.Schmuko.limits.free}€`);
          window.minmax.valid = false;
          openModal();
          e.preventDefault();
      }
    }
    });
  
    doc.addEventListener("DOMContentLoaded", async () => {
      // Prüfen ob ein Discount code aktiv ist
      if (window.sessionStorage.getItem("scDiscountData")) {
        const discountData = JSON.parse(window.sessionStorage.getItem("scDiscountData"));
        if (discountData.code && discountData.code !== "") {
          window.minmax.discountApplied = true;
          window.minmax.cart = discountData;
          validateCart(discountData);
        }
      }
      // Wenn vorhanden Cart daten laden
      if (window.minmax.discountApplied) {
        window.minmax.cart = JSON.parse(window.sessionStorage.getItem("scCartData"));
      } else {
        await fetch("/cart.js");
      }
    });
  })(window, document);
  
  window.Schmuko = window.Schmuko || {};

  
  
  window.Schmuko.cartValueCallback = async function (value) {
    console.log(`Cart value callback: ${value}`);
    if (value > 0 && document.getElementById("free-goal-percent")) {
      const left = window.Schmuko.freeGoal - value;
      console.log("left", left);
      const percent = 100 - (left / window.Schmuko.freeGoal) * 100;
      document.getElementById("free-goal-percent").style.width = `${percent}%`;
      document.getElementById("free-goal-left").textContent = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(left);
  
      const notReachedDiv = document.getElementById("free-goal-not-reached");
      const reachedDiv = document.getElementById("free-goal-reached");

      if (left < 0) {
        notReachedDiv.style.display = "none";
        reachedDiv.style.display = null;
      } else {
        reachedDiv.style.display = "none";
        notReachedDiv.style.display = null;
      }
    }
  };
